module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm2_en.0b0666d9970243052479d2eee48a6d7d.png";